import { ComponentProps } from 'react';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { getStaticImageSrc } from 'utils/getImageSrc';

import { StyledButton, TextContainer } from './AuthButton.styled';

type Props = ComponentProps<typeof AnchorButton> & {
  danger?: boolean;
};

export function FacebookButton({ children, size, danger, ...props }: Props) {
  return (
    <StyledButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      rel="nofollow"
      variant={danger ? 'danger-outline' : 'secondary'}
      fullWidth
      size={size}
    >
      <Box width={1} display="flex" alignItems="center" justifyContent="center">
        <img
          src={getStaticImageSrc('icons/social/facebook-new.svg')}
          width={24}
          height={24}
          alt="Google"
        />
        <TextContainer>
          {children || getText('Continue with Facebook')}
        </TextContainer>
      </Box>
    </StyledButton>
  );
}

export function GoogleButton({ children, size, danger, ...props }: Props) {
  return (
    <StyledButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      rel="nofollow"
      variant={danger ? 'danger-outline' : 'secondary'}
      fullWidth
      size={size}
    >
      <Box width={1} display="flex" alignItems="center" justifyContent="center">
        <img
          src={getStaticImageSrc('icons/social/google.svg')}
          width={24}
          height={24}
          alt="Google"
        />
        <TextContainer>
          {children || getText('Continue with Google')}
        </TextContainer>
      </Box>
    </StyledButton>
  );
}

export function AppleButton({ children, size, danger, ...props }: Props) {
  return (
    <StyledButton
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      rel="nofollow"
      variant={danger ? 'danger-outline' : 'secondary'}
      fullWidth
      size={size}
    >
      <Box width={1} display="flex" alignItems="center" justifyContent="center">
        <img
          src={getStaticImageSrc('icons/social/apple.svg')}
          width={24}
          height={24}
          alt="Apple"
        />
        <TextContainer>
          {children || getText('Continue with Apple')}
        </TextContainer>
      </Box>
    </StyledButton>
  );
}
